import { Component, inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  FullSocialIconConfig,
  SOCIAL_ICON_CONFIG,
  SocialIconTooltips,
  addIconClass,
  socialIconLocalization,
} from './footer.types';
import { SvgIconComponent } from '../../shared/components/svg-icon/svg-icon.component';
import { LangService } from '../../shared/services/lang/lang.service';

@Component({
  selector: 'app-footer',
  imports: [MatTooltipModule, SvgIconComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private langService = inject(LangService);
  private localizeIcons = socialIconLocalization(SOCIAL_ICON_CONFIG);
  labels = this.langService.lang.core.footer;
  private socialIconTooltips: SocialIconTooltips =
    this.labels.socialIconsTooltips;

  anio: number = new Date().getFullYear();
  socialIcons: FullSocialIconConfig[] = addIconClass(
    this.localizeIcons(this.socialIconTooltips),
  );
}
